// How the two cargo answers read off an order are shown: the yes/no behind
// pallet exchange and the required transport temperature. Shared by the order
// check card, the order details dialog and the planner, so "Tak"/"Nie" and
// "-22 °C" are spelt the same everywhere.
//
// i18n.t at call time (not at module load): callers re-render on a language
// switch through their own useTranslation.

import i18n from "@/lib/i18n/i18n"

export const formatPalletExchangeValue = (
  value?: boolean,
): string | undefined => {
  if (value === true) return i18n.t("orders.cargo.yes")
  if (value === false) return i18n.t("orders.cargo.no")
  return undefined
}

// "-22 °C" for a set point, "2 – 8 °C" for a range, one-sided when only one
// bound is known.
export const formatTemperatureRange = (
  min?: number,
  max?: number,
): string | undefined => {
  if (min == null && max == null) return undefined
  if (min != null && max != null) {
    return min === max ? `${min} °C` : `${min} – ${max} °C`
  }
  return min != null
    ? i18n.t("orders.cargo.temperatureFrom", { value: min })
    : i18n.t("orders.cargo.temperatureTo", { value: max })
}
